import { render, staticRenderFns } from "./OtherServiceType.vue?vue&type=template&id=34ab24bc&"
import script from "./OtherServiceType.vue?vue&type=script&lang=js&"
export * from "./OtherServiceType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports